
import React, { useState } from 'react';
import {
  Box,
  Button,
  Step,
  StepLabel,
  Stepper,
  Typography,
  Alert,
  Paper
} from '@mui/material';
import {ArrowForward as NextIcon, ArrowBack as PrevIcon } from '@mui/icons-material';
import { WorkshopStepProps } from './WorkshopStep';



type WorkshopComponentProps = {
    title?: string;
    steps: WorkshopStepProps[];
}

const WorkshopComponent: React.FC<WorkshopComponentProps> = ({ title, steps }) => {
  const [error, setError] = useState<string | null>(null);
  const [activeStep, setActiveStep] = useState(0);

  function handleNext() {
    setActiveStep(prev => prev + 1);
    if (steps[activeStep]?.onContinue) {
      steps[activeStep].onContinue?.();
    }
  }

  function handlePrev() {
    setActiveStep(prev => prev - 1);
  }


return (
    <Paper sx={{ p: 4, mb: 4 }} elevation={3}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4">{title}</Typography>
        <Stepper activeStep={activeStep} alternativeLabel sx={{ maxWidth: 560 }}>
            {steps.map(step => (
            <Step key={step.title}>
                <StepLabel>{step.title}</StepLabel>
            </Step>
            ))}
        </Stepper>
        </Box>
        {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
                {error}
                </Alert>
            )}
        {steps[activeStep].children}
        
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px', paddingLeft: '24px', paddingRight: '24px' }}>
        {activeStep > 0 && (
            <Button
                onClick={handlePrev}
                variant="contained"
                endIcon={<PrevIcon />}
                disabled={activeStep === 0}
                style={{ marginRight: 'auto' }}
            >
                Back
            </Button>
        )}
        {activeStep < steps.length - 1 && (
        <Button
            onClick={handleNext}
            variant="contained"
            endIcon={<NextIcon />}
            disabled={!steps[activeStep]?.canProceed || (false as boolean)}
            style={{ marginLeft: 'auto' }}
            >
                Continue
            </Button>
        )}
        </div>
    </Paper>
)};

export default WorkshopComponent;